import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Lightning, FilmStrip, ArrowRight } from '@phosphor-icons/react';

export const TUTORIALS = [
  {
    slug: 'precall-brief',
    src: '/videocrunch-precall-brief.mp4',
    poster: '/videocrunch-poster-precall-brief.jpg',
    title: 'Pre-Call Brief — Crunchy preps you before every call',
    description: 'Open a contact with a meeting today and Crunchy has already read the file: who they are, where you left off, and a suggested opening line.',
    duration: 'PT1M4S',
  },
  {
    slug: 'ghostbuster',
    src: '/videocrunch-ghostbuster.mp4',
    poster: '/videocrunch-poster-ghostbuster.jpg',
    title: 'GhostBuster — revive deals that went quiet',
    description: 'GhostBuster flags deals with no touch in 14 days and drafts the re-engagement email from your own notes — one click to your composer.',
    duration: 'PT56S',
  },
  {
    slug: 'lookup',
    src: '/videocrunch-lookup.mp4',
    poster: '/videocrunch-poster-lookup.jpg',
    title: 'Lookup — filter your contacts in seconds',
    description: 'Run a Boolean Lookup and watch it follow you across the Contact List and Print & Merge, with your matches pre-selected.',
    duration: 'PT1M4S',
  },
  {
    slug: 'smart-import',
    src: '/videocrunch-smart-import.mp4',
    poster: '/videocrunch-poster-smart-import.jpg',
    title: 'Smart Import — your whole spreadsheet, in under a minute',
    description: 'Upload a CSV with messy headers and watch the AI map every field, run a pre-flight check, and import everything in one click.',
    duration: 'PT1M2S',
  },
  {
    slug: 'mail-merge',
    src: '/videocrunch-mail-merge.mp4',
    poster: '/videocrunch-poster-mail-merge.jpg',
    title: 'Mail Merge — a personalized letter for every contact',
    description: 'Pick a template, select your contacts, and generate print-ready personalized letters — or send them as email.',
    duration: 'PT57S',
  },
  {
    slug: 'crunchy',
    src: '/videocrunch-crunchy.mp4',
    poster: '/videocrunch-poster-crunchy.jpg',
    title: 'Meet Crunchy — the AI assistant that knows your data',
    description: 'Ask a question in plain English and watch Crunchy query your live database for the real answer.',
    duration: 'PT52S',
  },
  {
    slug: 'lookup-smartgroup',
    src: '/videocrunch-lookup-smartgroup.mp4',
    poster: '/videocrunch-poster-lookup-smartgroup.jpg',
    title: 'The Lookup ACT! users miss — plus Smart Groups',
    description: 'Stack Boolean conditions (all leads, then State = TX), then save the query as a Smart Group that updates itself forever.',
    duration: 'PT1M18S',
  },
  {
    slug: 'quick-add',
    src: '/videocrunch-quick-add.mp4',
    poster: '/videocrunch-poster-quick-add.jpg',
    title: 'Quick Add — a contact in 5 seconds',
    description: 'Hit Ctrl+K anywhere in the app, tab through name, company, phone and email, hit save — the new card opens instantly.',
    duration: 'PT59S',
  },
  {
    slug: 'crunchy-bulk-email',
    src: '/videocrunch-crunchy-bulk-email.mp4',
    poster: '/videocrunch-poster-crunchy-bulk-email.jpg',
    title: 'Crunchy drafts a whole email campaign from one sentence',
    description: '"Write a touching-base email to all my leads in Texas" — Crunchy finds the contacts and drafts the email. You approve before anything sends.',
    duration: 'PT1M4S',
  },
  {
    slug: 'calendar',
    src: '/videocrunch-calendar.mp4',
    poster: '/videocrunch-poster-calendar.jpg',
    title: 'Calendar — your whole month at a glance',
    description: 'Calls, meetings and to-dos, color-coded on a monthly grid. Click any day to see its schedule and add something right there.',
    duration: 'PT51S',
  },
  {
    slug: 'tasks',
    src: '/videocrunch-tasks.mp4',
    poster: '/videocrunch-poster-tasks.jpg',
    title: 'Tasks — everything you owe anybody, in one place',
    description: 'Create a task with a due date, priority and a note. One click checks it off — and it\'s logged to history automatically.',
    duration: 'PT47S',
  },
  {
    slug: 'alarms',
    src: '/videocrunch-alarms.mp4',
    poster: '/videocrunch-poster-alarms.jpg',
    title: 'Alarms — your follow-ups chase you',
    description: 'Press Ctrl+B anywhere for the ACT!-style alarms panel: overdue on top, today below, and one click rolls everything overdue into today.',
    duration: 'PT45S',
  },
  {
    slug: 'notes',
    src: '/videocrunch-notes.mp4',
    poster: '/videocrunch-poster-notes.jpg',
    title: 'Notes & History — the relationship memory',
    description: 'Log a note from the card toolbar in ten seconds. It lands on the Notes tab and is stamped into History — date, time, and author. Forever.',
    duration: 'PT54S',
  },
  {
    slug: 'pipeline',
    src: '/videocrunch-pipeline.mp4',
    poster: '/videocrunch-poster-pipeline.jpg',
    title: 'Pipeline — deals on a board, money in motion',
    description: 'Every column is a stage, every card is a deal linked to its contact. Drag between stages as it moves; pipeline value totals up top.',
    duration: 'PT50S',
  },
  {
    slug: 'reports',
    src: '/videocrunch-reports.mp4',
    poster: '/videocrunch-poster-reports.jpg',
    title: 'Reports that respect your Lookup',
    description: 'Run a lookup, open Reports, and the report already knows which contacts you mean — a history summary for exactly those records.',
    duration: 'PT54S',
  },
  {
    slug: 'groups',
    src: '/videocrunch-groups.mp4',
    poster: '/videocrunch-poster-groups.jpg',
    title: 'Groups & Smart Groups — lists that maintain themselves',
    description: 'Hand-picked groups and self-updating smart groups, side by side. Groups feed everything: mail merge, bulk email, reports.',
    duration: 'PT47S',
  },
  {
    slug: 'templates',
    src: '/videocrunch-templates.mp4',
    poster: '/videocrunch-poster-templates.jpg',
    title: 'Templates — write it once, reuse it forever',
    description: 'Build an email template with {{merge}} tokens for name and company. Every token fills in per contact — in mail merge, bulk email, and one-off sends.',
    duration: 'PT55S',
  },
  {
    slug: 'labels-envelopes',
    src: '/videocrunch-labels-envelopes.mp4',
    poster: '/videocrunch-poster-labels-envelopes.jpg',
    title: 'Labels & Envelopes — because stamps still close deals',
    description: 'Avery-ready label sheets and properly formatted envelopes for any lookup or selection. Direct mail in two minutes.',
    duration: 'PT50S',
  },
  {
    slug: 'merge-duplicates',
    src: '/videocrunch-merge-duplicates.mp4',
    poster: '/videocrunch-poster-merge-duplicates.jpg',
    title: 'Merge Duplicates — a clean database in one click',
    description: 'Scan the whole database for duplicate contacts, review matches side by side, and merge — keeping the best data, notes and history from both.',
    duration: 'PT46S',
  },
  {
    slug: 'custom-fields',
    src: '/videocrunch-custom-fields.mp4',
    poster: '/videocrunch-poster-custom-fields.jpg',
    title: 'Custom dropdown lists — make the CRM speak your language',
    description: 'Create a dropdown list once and it appears on every contact card — consistent data, no typos. Exactly how ACT! did it.',
    duration: 'PT45S',
  },
  {
    slug: 'export',
    src: '/videocrunch-export.mp4',
    poster: '/videocrunch-poster-export.jpg',
    title: 'Export — your data is yours, always',
    description: 'One click exports a full CSV: every contact, every field, every custom column. No lock-in, no export fees, no begging support.',
    duration: 'PT36S',
  },
  {
    slug: 'contact-editing',
    src: '/videocrunch-contact-editing.mp4',
    poster: '/videocrunch-poster-contact-editing.jpg',
    title: 'The Contact Card — edit, tag, navigate',
    description: 'Lookup a record, fix a phone number in place, add a tag, save — then flip through records with the prev/next arrows, pure ACT! muscle memory.',
    duration: 'PT1M0S',
  },
  {
    slug: 'search',
    src: '/videocrunch-search.mp4',
    poster: '/videocrunch-poster-search.jpg',
    title: 'Global Search — one box, your whole database',
    description: 'Type a name, a company, or a word you remember from a note. Contacts, activities and notes matched and highlighted — click straight to the card.',
    duration: 'PT43S',
  },
  {
    slug: 'relationships',
    src: '/videocrunch-relationships.mp4',
    poster: '/videocrunch-poster-relationships.jpg',
    title: 'Relationships — map who knows who',
    description: 'Link contacts to each other — referred by, colleague, spouse. The link shows from both sides, so the whole network is one click away.',
    duration: 'PT49S',
  },
  {
    slug: 'recurring',
    src: '/videocrunch-recurring.mp4',
    poster: '/videocrunch-poster-recurring.jpg',
    title: 'Recurring Activities — schedule it once',
    description: 'A weekly check-in call, scheduled four weeks out in one save. The whole series lands on your task list and calendar automatically.',
    duration: 'PT55S',
  },
  {
    slug: 'pipeline-drag',
    src: '/videocrunch-pipeline-drag.mp4',
    poster: '/videocrunch-poster-pipeline-drag.jpg',
    title: 'Pipeline Drag — move deals as they move',
    description: 'Grab a deal card and drop it in the next stage. Stage saved, column totals updated, history intact — money in motion, one drag at a time.',
    duration: 'PT38S',
  },
  {
    slug: 'user-fields',
    src: '/videocrunch-user-fields.mp4',
    poster: '/videocrunch-poster-user-fields.jpg',
    title: 'User Fields — rename them to match your business',
    description: 'Ten ACT!-style user fields on every card. Admins click the pencil, rename "User 1" to whatever you actually track, and it updates everywhere instantly.',
    duration: 'PT1M22S',
  },
];

export default function TutorialsPage() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Video Tutorials — SalesCrunchCRM';
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute('content');
    meta?.setAttribute('content', 'Watch 60-second video tutorials for SalesCrunchCRM: Lookup, Smart Import, Mail Merge, Calendar, Tasks, Pipeline, Reports, and Crunchy the AI assistant.');

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': TUTORIALS.map(t => ({
        '@type': 'VideoObject',
        name: t.title,
        description: t.description,
        contentUrl: `${window.location.origin}${t.src}`,
        thumbnailUrl: `${window.location.origin}${t.poster}`,
        duration: t.duration,
        uploadDate: '2026-06-14T08:00:00+00:00',
        publisher: { '@type': 'Organization', name: 'SalesCrunchCRM' },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.title = prevTitle;
      if (prevDesc) meta?.setAttribute('content', prevDesc);
      script.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="tutorials-page">
      <header className="border-b border-slate-200 px-6 py-4">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="tutorials-home-link">
            <div className="w-8 h-8 bg-[#002FA7] rounded flex items-center justify-center">
              <span className="text-white font-black text-sm">SC</span>
            </div>
            <span className="text-lg font-black tracking-tight">SalesCrunch<span className="text-[#F39C12]">CRM</span></span>
          </Link>
          <nav className="flex items-center gap-5 text-sm">
            <Link to="/walkthrough" className="text-slate-600 hover:text-slate-900 hidden sm:inline">How it works</Link>
            <Link to="/login" className="text-slate-700 hover:text-slate-900 font-semibold" data-testid="tutorials-signin-link">Sign in</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12">
        <div className="mb-10">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-[#0B5394] bg-blue-50 border border-blue-200 rounded-full px-3 py-1 mb-4">
            <FilmStrip size={13} weight="bold" />Video Tutorials
          </div>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight mb-3">Learn SalesCrunch in 60-second bites.</h1>
          <p className="text-base text-slate-600 max-w-2xl">
            Real recordings of the actual product — no slides, no fluff. Each video shows one workflow, start to finish, in about a minute.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {TUTORIALS.map(t => (
            <section key={t.slug} className="border border-slate-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-testid={`tutorial-card-${t.slug}`}>
              <video
                controls
                preload="metadata"
                poster={t.poster}
                className="w-full aspect-video bg-slate-900"
                data-testid={`tutorial-video-${t.slug}`}
              >
                <source src={t.src} type="video/mp4" />
              </video>
              <div className="p-5">
                <h2 className="text-base font-bold mb-1.5">{t.title}</h2>
                <p className="text-sm text-slate-600 leading-relaxed">{t.description}</p>
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 bg-slate-900 rounded-xl px-8 py-10 text-center">
          <h2 className="text-lg font-bold text-white mb-2">Ready to try it yourself?</h2>
          <p className="text-sm text-slate-400 mb-6">14-day free trial. Free migration from your old CRM. $30/user/month after.</p>
          <Link
            to="/login"
            className="inline-flex items-center gap-2 bg-[#F39C12] hover:bg-[#D68910] text-slate-900 font-bold text-sm px-6 py-3 rounded-lg transition-colors"
            data-testid="tutorials-cta-btn"
          >
            <Lightning size={16} weight="bold" />Start your free trial<ArrowRight size={14} weight="bold" />
          </Link>
        </div>

        <p className="mt-8 text-center text-[11px] text-slate-400">
          Every video on this page was produced automatically by <Link to="/videocrunch" className="text-[#0B5394] font-bold hover:underline" data-testid="tutorials-videocrunch-link">VideoCrunch</Link> — our AI video engine. No camera. No actor. No editing.{' '}
          <Link to="/voice" className="text-[#0B5394] font-bold hover:underline" data-testid="tutorials-voice-link">Try the free Voiceover Corrector →</Link>
        </p>
      </main>
    </div>
  );
}
